<template>
    <v-dialog persistent v-model="dialog" width="30%">
        <v-card fluid>
            <v-card-title>
                {{ data.title }}
            </v-card-title>
            <v-divider class="ml-2 mr-2 mb-2"></v-divider>
            <v-card-text class="text-color">
                <div v-html="data.message"></div>
            </v-card-text>
            <v-divider  class="ml-2 mr-2"></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>              
                <v-btn small @click="close()" color="primary">{{ data.cancel }}</v-btn>                  
                <v-btn small @click="confirm()" color="warning">{{ data.confirm }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>   
export default {
    components: {
    },        
    data() {
        return {
            dialog: false,
            data: {}
        }
    },    
    methods: {
        open(param) {
            this.data = param
            this.dialog = true            
        },                    
        close() {
            this.dialog = false;
        },        
        confirm(){
            console.log(this.data.type)
            this.$emit('confirm', this.data.type);
            this.dialog = false;
        }
    }
}
</script>

<style scoped>
.flex-row{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.text-color{
    color: black !important;
}

</style>